import { render } from "./cad_index.vue?vue&type=template&id=f2ff1e74"
import script from "./cad_index.vue?vue&type=script&lang=js"
export * from "./cad_index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\software.icarusbd.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__